package ai.flowstorm.studio.resources

import ai.flowstorm.common.resources.AbstractResource
import ai.flowstorm.studio.model.CodeDebug
import io.kvision.rest.HttpMethod

object CodeDebugResource: AbstractResource<CodeDebug>("/debug", CodeDebug.serializer()) {
    suspend fun debugCode(code: CodeDebug): CodeDebug {
        return remoteCall("", code, HttpMethod.POST)
    }
}